import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import BpaSizer from '@/views/BpaSizer'
import UtilityCalcSizer from '@/views/UtilityCalcSizer'

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/sizer/:size?',
			component: BpaSizer,
		},
		{
			path: '/sizer-bpa/:size?',
			redirect: to => ({ path: `/sizer/${to.params.size || ''}`.replace(/\/$/, '') })
		},
		{
			path: '/sizer-utility-calc/:size?',
			component: UtilityCalcSizer,
		}
	],

	scrollBehavior () {
		return { top: 0, left: 0 }
	},
})


createApp(App).use(router).mount('#app')
